import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Box } from '@mui/material'
import TopNav from './TopNav'
import SidePanel from './SidePanel'

export default function Layout() {
  const [sidePanelOpen, setSidePanelOpen] = useState(true)

  const handleToggleSidePanel = () => {
    setSidePanelOpen((prev) => !prev)
  }

  const handleCloseSidePanel = () => {
    setSidePanelOpen(false)
  }

  return (
    <>
      <SidePanel open={sidePanelOpen} onClose={handleCloseSidePanel} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          marginLeft: sidePanelOpen ? '300px' : '0',
          transition: 'margin-left 0.225s cubic-bezier(0.4, 0, 0.2, 1)',
        }}
      >
        <TopNav onMenuClick={handleToggleSidePanel} sidePanelOpen={sidePanelOpen} />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            backgroundColor: '#ffffff',
            overflow: 'auto',
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </>
  )
}
